<app-cerrix-color-box [color]="color"></app-cerrix-color-box>
<span>{{ label }}</span>
